import React from 'react';
import Btn from '../Common/Btn';
import './PauseMenu.css'

const WinScreen = (props) => {
    return ( 
        <div className='PauseMenu'>
            <div className='PauseTitle'>
                <p>
                    Mission Successful
                </p>
            </div>

            <div className='MenuBtns'>
                <Btn BtnText='Quit' BtnStyle='BlueBtn' BtnPath='/'/>
                <Btn BtnText='Next Level' BtnStyle='GoldBtn' BtnPath={props.LevelPath}/>
            </div>
        </div>
     );
}
 
export default WinScreen;